<p>inventory-price-audit-trail works!</p>
